/* eslint-disable import/prefer-default-export */
export const feedbackCustomizations = {
  MuiDialog: {
    styleOverrides: {
      paper: {
        '@media (min-width:1920px)': {
          position: 'absolute',
          left: 0,
        }
      }
    },
  },
};
